import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';

const NotificationThemeTag = ({ name, slug }) => (
  <S.NotificationThemeTag themeSlug={slug}>{name}</S.NotificationThemeTag>
);

NotificationThemeTag.propTypes = {
  name: PropTypes.string,
  slug: PropTypes.string,
};

export { NotificationThemeTag };
